// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Blob, BlobT, verifyBlob } from "./blob";
import { BuildInfo, BuildInfoT, verifyBuildInfo } from "./build-info";
import { IdlBundle, IdlBundleT, verifyIdlBundle } from "./idl-bundle";
import { ProductType } from "./product-type";

export class Mapping implements flatbuffers.IUnpackableObject<MappingT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Mapping {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMapping(bb: flatbuffers.ByteBuffer, obj?: Mapping): Mapping {
    return (obj || new Mapping()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMapping(bb: flatbuffers.ByteBuffer, obj?: Mapping): Mapping {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Mapping()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static bufferHasIdentifier(bb: flatbuffers.ByteBuffer): boolean {
    return bb.__has_identifier("MCEM");
  }

  productType(): ProductType {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ProductType.M2000;
  }

  /**
   * The on-disk IDL path for an adapter without `idl`; a sentinel when
   * `overrides` or `idl.events_xml` is present.
   */
  idlFile(): string;
  idlFile(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  idlFile(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  eventMappingFile(): string | null;
  eventMappingFile(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  eventMappingFile(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  eventMappingData(): string | null;
  eventMappingData(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  eventMappingData(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  idl(obj?: IdlBundle): IdlBundle | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? (obj || new IdlBundle()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  translation(obj?: Blob): Blob | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new Blob()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  overrides(obj?: Blob): Blob | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new Blob()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  buildInfo(obj?: BuildInfo): BuildInfo | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new BuildInfo()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startMapping(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addProductType(builder: flatbuffers.Builder, productType: ProductType) {
    builder.addFieldInt8(0, productType, ProductType.M2000);
  }

  static addIdlFile(builder: flatbuffers.Builder, idlFileOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, idlFileOffset, 0);
  }

  static addEventMappingFile(
    builder: flatbuffers.Builder,
    eventMappingFileOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(3, eventMappingFileOffset, 0);
  }

  static addEventMappingData(
    builder: flatbuffers.Builder,
    eventMappingDataOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(4, eventMappingDataOffset, 0);
  }

  static addIdl(builder: flatbuffers.Builder, idlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, idlOffset, 0);
  }

  static addTranslation(builder: flatbuffers.Builder, translationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, translationOffset, 0);
  }

  static addOverrides(builder: flatbuffers.Builder, overridesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, overridesOffset, 0);
  }

  static addBuildInfo(builder: flatbuffers.Builder, buildInfoOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, buildInfoOffset, 0);
  }

  static endMapping(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // idl_file
    return offset;
  }

  static finishMappingBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, "MCEM");
  }

  static finishSizePrefixedMappingBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, "MCEM", true);
  }

  unpack(): MappingT {
    return new MappingT(
      this.productType(),
      this.idlFile(),
      this.eventMappingFile(),
      this.eventMappingData(),
      this.idl() !== null ? this.idl()!.unpack() : null,
      this.translation() !== null ? this.translation()!.unpack() : null,
      this.overrides() !== null ? this.overrides()!.unpack() : null,
      this.buildInfo() !== null ? this.buildInfo()!.unpack() : null,
    );
  }

  unpackTo(_o: MappingT): void {
    _o.productType = this.productType();
    _o.idlFile = this.idlFile();
    _o.eventMappingFile = this.eventMappingFile();
    _o.eventMappingData = this.eventMappingData();
    _o.idl = this.idl() !== null ? this.idl()!.unpack() : null;
    _o.translation = this.translation() !== null ? this.translation()!.unpack() : null;
    _o.overrides = this.overrides() !== null ? this.overrides()!.unpack() : null;
    _o.buildInfo = this.buildInfo() !== null ? this.buildInfo()!.unpack() : null;
  }

  unpackFields(...fields: string[]): MappingT {
    const t = new MappingT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("product_type")) {
      t.productType = this.productType();
    }
    if (fieldSet.has("idl_file")) {
      t.idlFile = this.idlFile();
    }
    if (fieldSet.has("event_mapping_file")) {
      t.eventMappingFile = this.eventMappingFile();
    }
    if (fieldSet.has("event_mapping_data")) {
      t.eventMappingData = this.eventMappingData();
    }
    if (fieldSet.has("idl")) {
      t.idl = this.idl() !== null ? this.idl()!.unpack() : null;
    }
    if (fieldSet.has("translation")) {
      t.translation = this.translation() !== null ? this.translation()!.unpack() : null;
    }
    if (fieldSet.has("overrides")) {
      t.overrides = this.overrides() !== null ? this.overrides()!.unpack() : null;
    }
    if (fieldSet.has("build_info")) {
      t.buildInfo = this.buildInfo() !== null ? this.buildInfo()!.unpack() : null;
    }
    return t;
  }
}

export class MappingT implements flatbuffers.IGeneratedObject {
  constructor(
    public productType: ProductType = ProductType.M2000,
    public idlFile: string | Uint8Array | null = null,
    public eventMappingFile: string | Uint8Array | null = null,
    public eventMappingData: string | Uint8Array | null = null,
    public idl: IdlBundleT | null = null,
    public translation: BlobT | null = null,
    public overrides: BlobT | null = null,
    public buildInfo: BuildInfoT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.idlFile === null || this.idlFile === undefined) {
      throw new Error('Required field "idl_file" is not set');
    }
    const idlFile = this.idlFile !== null ? builder.createString(this.idlFile!) : 0;
    const eventMappingFile =
      this.eventMappingFile !== null ? builder.createString(this.eventMappingFile!) : 0;
    const eventMappingData =
      this.eventMappingData !== null ? builder.createString(this.eventMappingData!) : 0;
    const idl = this.idl !== null ? this.idl!.pack(builder) : 0;
    const translation = this.translation !== null ? this.translation!.pack(builder) : 0;
    const overrides = this.overrides !== null ? this.overrides!.pack(builder) : 0;
    const buildInfo = this.buildInfo !== null ? this.buildInfo!.pack(builder) : 0;

    Mapping.startMapping(builder);
    Mapping.addProductType(builder, this.productType);
    Mapping.addIdlFile(builder, idlFile);
    Mapping.addEventMappingFile(builder, eventMappingFile);
    Mapping.addEventMappingData(builder, eventMappingData);
    Mapping.addIdl(builder, idl);
    Mapping.addTranslation(builder, translation);
    Mapping.addOverrides(builder, overrides);
    Mapping.addBuildInfo(builder, buildInfo);

    return Mapping.endMapping(builder);
  }

  clone(): MappingT {
    const obj = new MappingT();
    obj.productType = this.productType;
    obj.idlFile = this.idlFile;
    obj.eventMappingFile = this.eventMappingFile;
    obj.eventMappingData = this.eventMappingData;
    obj.idl = this.idl !== null ? this.idl!.clone() : null;
    obj.translation = this.translation !== null ? this.translation!.clone() : null;
    obj.overrides = this.overrides !== null ? this.overrides!.clone() : null;
    obj.buildInfo = this.buildInfo !== null ? this.buildInfo!.clone() : null;
    return obj;
  }

  equals(other: MappingT): boolean {
    if (this.productType !== other.productType) return false;
    if (this.idlFile !== other.idlFile) return false;
    if (this.eventMappingFile !== other.eventMappingFile) return false;
    if (this.eventMappingData !== other.eventMappingData) return false;
    if (this.idl !== null && other.idl !== null) {
      if (!this.idl!.equals(other.idl!)) return false;
    } else if (this.idl !== other.idl) return false;
    if (this.translation !== null && other.translation !== null) {
      if (!this.translation!.equals(other.translation!)) return false;
    } else if (this.translation !== other.translation) return false;
    if (this.overrides !== null && other.overrides !== null) {
      if (!this.overrides!.equals(other.overrides!)) return false;
    } else if (this.overrides !== other.overrides) return false;
    if (this.buildInfo !== null && other.buildInfo !== null) {
      if (!this.buildInfo!.equals(other.buildInfo!)) return false;
    } else if (this.buildInfo !== other.buildInfo) return false;
    return true;
  }
}

export function verifyMapping(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "idl_file");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 14);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlBundle(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 16);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyBlob(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 18);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyBlob(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 20);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyBuildInfo(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsMapping(buf: DataView, opts?: flatbuffers.VerifierOptions): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyMapping(verifier, tablePos);
}
